import axios from 'utils/requestHelper';

const fetchAll = (params) => axios.get('v1/clients/models', { params });

const ModelAPI = {
  fetchAll,
};

export default ModelAPI;
